import { LBtn, LInputField } from "@components";
import { searchUpcomingAssessmentsFilter } from "@fadmin/tabs/results/components/filterHelper";
import { UpcomingAssessment } from "@store/locationsSlice";
import { ChangeEvent, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { LeftSide } from "./LeftSide";
import { RightSide } from "../right-side/RightSide";

export const UpcomingAssessments = ({
    assessments,
    disableButtons,
    onClick
}: UpcomingAssessmentsProps): JSX.Element => {
    const validateMethods = useForm();

    const [selectedExaminee, setSelectedExaminee] = useState<UpcomingAssessment>();
    const [searchValue, setSearchValue] = useState("");

    const handleSelectExaminee = (examinee: UpcomingAssessment): void => {
        setSelectedExaminee(examinee);
    };

    const handleSearch = (e: ChangeEvent<HTMLInputElement>): void => {
        setSearchValue(e.target.value);
    };

    useEffect(() => {
        if (!selectedExaminee) {
            return;
        }

        const updatedSelectedExaminee = assessments.find((assessment) => assessment.id === selectedExaminee.id);

        if (updatedSelectedExaminee && updatedSelectedExaminee !== selectedExaminee) {
            setSelectedExaminee(updatedSelectedExaminee);
        }
    }, [assessments, selectedExaminee?.id]);

    const filteredExaminees = searchUpcomingAssessmentsFilter(searchValue, assessments);

    return (
        <div>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-5">
                <div className="mx-6 minw-40">
                    <FormProvider {...validateMethods}>
                        <LInputField
                            inputName="search"
                            placeholder="Search examinees"
                            isSearch={true}
                            onChange={handleSearch}
                            isExpanded
                            isRounded
                            hideErrorLabel
                        />
                    </FormProvider>
                </div>
                <LBtn
                    isBold
                    disabled={disableButtons}
                    toolTipText={
                        "Your account is out of assessments. More can be purchased in the \"Manage\" section of the LASSI-D™ portal."
                    }
                    onClick={onClick}
                >
                    + Add Assessment
                </LBtn>
            </div>
            <div className="columns">
                <LeftSide assessments={filteredExaminees} handleSelectExaminee={handleSelectExaminee} />
                <RightSide upcomingAssessment={selectedExaminee} />
            </div>
        </div>
    );
};

interface UpcomingAssessmentsProps {
    assessments: UpcomingAssessment[];
    disableButtons?: boolean;
    onClick: () => void;
}
